import React from "react";
import classNames from "classnames";
import style from "./style.scss";

export const Section = ({ divide, align, children }) => {
    return (
        <section
            className={classNames(style.base, {
                [style.divideNone]: divide === "none",
                [style.divideTiny]: divide === "tiny",
                [style.divideSmall]: divide === "small",
                [style.divideMedium]: divide === "medium",
                [style.divideLarge]: divide === "large",

                [style.alignCenter]: align === "center"
            })}
        >
            {children}
        </section>
    );
};
